import type { ResizableHandleProps } from './types';

/**
 * Vestigial after the DS SidePanel cutover — the DS panel renders its own
 * left-edge drag handle (lg+), so pages no longer need a sibling handle.
 * Kept (rendering nothing) because pages still mount it beside SidePanel.
 */
export function ResizableHandle(_props: ResizableHandleProps) {
  return null;
}
